import { useAuth0 } from "@auth0/auth0-react";

import { clearAppLocalStorage } from "../../utils/utils";
import { COLORS, FONT_FAMILY } from "../MaintenancePage/styles";
import WieldyLogo from "../MaintenancePage/WieldyLogo";

export default function NoOrganizationPage() {
  const { logout } = useAuth0();

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 40,
        background: COLORS.bg,
      }}
    >
      <WieldyLogo />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
          width: 560,
          maxWidth: "calc(100% - 32px)",
          background: COLORS.cardBg,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 16,
          padding: "48px 48px 40px 48px",
          boxShadow: "0 8px 32px rgba(10, 11, 15, 0.08)",
        }}
      >
        <h1
          style={{
            margin: 0,
            fontFamily: FONT_FAMILY,
            fontSize: 28,
            fontWeight: 600,
            color: COLORS.textPrimary,
            letterSpacing: -0.5,
            textAlign: "center",
          }}
        >
          No organization access
        </h1>
        <p
          style={{
            margin: 0,
            fontFamily: FONT_FAMILY,
            fontSize: 15,
            fontWeight: 400,
            color: COLORS.textSecondary,
            lineHeight: 1.6,
            textAlign: "center",
          }}
        >
          You are not a member of any organization. Please contact your account
          administrator to request access.
        </p>
        <div style={{ width: "100%", height: 1, background: COLORS.border }} />
        <button
          type="button"
          onClick={() => {
            clearAppLocalStorage();
            logout();
          }}
          style={{
            fontFamily: FONT_FAMILY,
            fontSize: 14,
            fontWeight: 500,
            color: "#FFFFFF",
            background: COLORS.dark,
            border: "none",
            borderRadius: 8,
            padding: "10px 24px",
            cursor: "pointer",
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}
